import { Category } from "../../../news_components/news_content/model/category";

export class Album{
    constructor(data){
        this.id = data.id;
        this.img = data.img;
        this.link = data.link;
        this.music_tracks = data.music_tracks;
        this.videos = data.videos;
        this.category = new Category(data.category_data);
        this.title = data.title;
        this.description = data.description;
        this.description_eng = data.description_eng;
        this.slug = data.slug;
    } 
}